<template>
    <div class="border-work">
      <div class="left">
        <img src="/static/img/acCleaning/svg/technician.svg" class="img-technician">
        <div>
          <h4 data-aos="fade-left" >{{ $t('ac_cleaning.apply_for_work_section.title') }}</h4>
          <p data-aos="fade-right" class="sub-text">{{ $t('ac_cleaning.apply_for_work_section.subtitle') }}</p>
        </div>
      </div>
      <div class="">
        <a class="button py-4" 
          :href="socialContacts.professionalLineUrl" target="_blank">
            <img src="/static/img/acCleaning/svg/line-logo.svg" class="img-line">
            <p style="color: #009A54;">{{ $t('ac_cleaning.apply_for_work_section.line_contact') }}</p>
        </a>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      socialContacts: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        title: 'สนใจสมัครเป็นคุณช่างกับ BeNeat',
        subtitle: 'On-demand Cleaning Service บริการทำความสะอาดที่ดีที่สุด'
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  @import '../../../static/sass/page/ac_cleaning.scss';
  
  .border-work {
    margin-top: 5%;
    border: 1px solid;
    border-radius: 24px;
    border-color: $secon-color;
    background-color: white;
    padding: 20px 40px;
    width: 100%;
  }
  
  p {
    margin: 0;
  }
  
  .left {
    display: block;
    place-items: center;
    text-align: center;
  }
  
  .button {
    display: flex;
    align-items: center;
    gap: 8px;
    justify-content: center;
    background-color: #EBF7F2;
    color: #009A54 !important;
    font-size: 18px;
    font-weight: 400;
    text-align: center;
    padding: 10px 30px;
    border-radius: 8px;
    cursor: pointer;
    margin-top: 10px;
    transition-duration: 700ms;
  }
  
  .button:hover {
    background-color: #d5ebe2;
    transition-duration: 700ms;
  }
  
  .img-line {
    height: 24px;
    width: 24px;
  }
  
  .img-technician {
    height: 64px;
    width: 64px;
  }
  
  @media (min-width: 1024px) {
    .border-work {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  
    .title {
      font-size: 32px;
      font-weight: 500;
      color: black;
    }
  
    .left {
      display: flex;
      align-items: center;
      gap: 32px;
      text-align: left;
    }
  
    .right {
      margin-top: 0;
    }
  
    .button {
      font-weight: 500;
    }
  
    .img-line {
      height: 32px;
      width: 32px;
    }
  
    .img-technician {
      height: 96px;
      width: 96px;
    }
  }
  </style>


// WEBPACK FOOTER //
// src/components/acCleaningRe/ApplyForWork.vue